var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      staticClass: "order-trend-inner",
    },
    [_c("div", { ref: "chartEl", staticClass: "trend-chart" })]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }